import React from 'react';
import { Company } from '../../types/api/Company';
import { useApi } from '../../hooks/useApi';
import { ActionButtons } from '../../globalComponents/modal/ActionButtons';
import { toastSuccess } from '../../Toaster/Toast.tsx';

const DeleteCompanyConfirmationModal:React.FC<{company: Company;}> = ({ company }) => {
    const api = useApi();

    return (
        <div className="flex flex-col gap-[20px]">
            <p className="font-bold">Delete Company Confirmation</p>
            <hr></hr>
            <p>Are you sure you want to delete company: {company.name}?</p>
            <ActionButtons
                confirmButtonStyle="success"
                confirmButtonText="Delete"
                confirmCallback={async () => {
                    await api.company.deleteCompany(company.tenantId, company._id);

                    toastSuccess({
                        title: 'Company Deleted',
                        description: `You have successfully deleted company: ${company.name}`,
                    });
                    window.location.reload()

                }}
            />
        </div>
    );
};


export default DeleteCompanyConfirmationModal;